import { Transcription } from '../models/transcription'
import { baseApi } from './base'

export type StartRecordingDto = {
  meetingId: string
  consultationId: string
}

export type RecordingResponse = {
  pipelineId: string
  mediaCapturePipelineArn: string
}

export type StopRecordingDto = {
  consultationId: string
  userId: string
}

export type RecoverRecordingsDto = {
  consultationId: string
}

export type RecoverRecordingsResponse = {
  ok: boolean
  recordsProcessed?: number
  consultationId?: string
  error?: string
}

export const recordingApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    startRecording: builder.mutation<RecordingResponse, StartRecordingDto>({
      query: (body) => ({
        url: '/recording/start',
        method: 'POST',
        body,
      }),
    }),
    stopRecording: builder.mutation<Transcription, StopRecordingDto>({
      query: (body) => ({
        url: `/recording/stop`,
        method: 'POST',
        body,
      }),
    }),
    getPresignedUrl: builder.mutation<string, { key: string }>({
      query: (body) => ({
        url: '/recording/get-presigned-url',
        method: 'POST',
        body,
      }),
    }),
    recoverRecordings: builder.mutation<RecoverRecordingsResponse, RecoverRecordingsDto>({
      query: (body) => ({
        url: '/recording/recover-recordings',
        method: 'POST',
        body,
      }),
    }),
  }),
})

export const {
  useStartRecordingMutation,
  useStopRecordingMutation,
  useGetPresignedUrlMutation,
  useRecoverRecordingsMutation,
} = recordingApi
